import {api} from './api'
import {ApiResponse, ThemeSetting} from '../types'

export const getThemeSettings = async (): Promise<ThemeSetting[]> => {
    try {
        const response = await api.get<ApiResponse<ThemeSetting[]>>('/api/admin/theme')
        return response.data.data || []
    } catch (error) {
        console.error('Error fetching theme settings:', error)
        return []
    }
}

export const updateThemeSetting = async (key: string, value: string): Promise<boolean> => {
    try {
        const response = await api.post('/api/admin/theme/update', {key, value})
        return response.data.success
    } catch (error) {
        console.error('Error updating theme setting:', error)
        return false
    }
}